<template>
  <div>
    <div style="padding-top: 55px" />
    <div
      class="album py-5 bg-light"
      style="overflow: auto; height: calc(100vh - 55px)"
    >
      <div class="container">
        <b-nav tabs class="mb-4">
          <b-nav-item
            :to="'/admin/users'"
            :active="$route.path === '/admin/users'"
          >
            사용자 관리
          </b-nav-item>
          <b-nav-item
            v-if="$store.getters['user/canViewQuotas']"
            :to="'/admin/quotas'"
            :active="$route.path === '/admin/quotas'"
          >
            API 데모 관리
          </b-nav-item>
          <b-nav-item
            v-if="$store.getters['user/canManageUsers']"
            :to="'/admin/api-unlimited-institutions'"
            :active="$route.path === '/admin/api-unlimited-institutions'"
          >
            API 본 계약 관리
          </b-nav-item>
          <b-nav-item
            v-if="$store.getters['user/canManageKeys']"
            :to="'/admin/keys'"
            :active="$route.path === '/admin/keys'"
          >
            API Keys
          </b-nav-item>
          <b-nav-item
            v-if="$store.getters['user/canManageUsers']"
            :to="'/admin/prepaid'"
            :active="$route.path === '/admin/prepaid'"
          >
            선불 크레딧
          </b-nav-item>
        </b-nav>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminLayout"
};
</script>
